import { formatUrl } from "@lexical/link";
import { sanitizeUrl } from "../../../format/index.js";
const url_sanitizeUrl = (url)=>sanitizeUrl(formatUrl(url));
export { url_sanitizeUrl as sanitizeUrl };
